import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { StatusCode, type PaginatedFoodFeedbackList } from '@hungryroot/rest';
import {
  getApiV2FoodFeedback,
  type Params,
} from '@hungryroot/rest/api/v2/food_feedback/get';

type UseFoodFeedbackProps = {
  params?: Params;
  options: Omit<
    UseQueryOptions<PaginatedFoodFeedbackList>,
    'queryFn' | 'queryKey'
  >;
};

export function useFoodFeedback(props: UseFoodFeedbackProps) {
  const { params, options } = props;
  return useQuery({
    queryKey: ['food_feedback', params],
    queryFn: async () => {
      const res = await getApiV2FoodFeedback(params);

      if (res.status !== StatusCode.SuccessOK) {
        throw new Error(JSON.stringify(res.data, null, 2));
      }

      return res.data;
    },
    ...options,
  });
}

export const foodFeedbackIdMap = {
  Taste: 1,
  Ingredients: 2,
  Nutrition: 3,
  PortionSize: 4,
  Value: 5,
  TimeEffort: 6,
  ItemIssue: 7,
  Other: 8,
} as const;
